import { Link } from '@remix-run/react'
import { EarthIcon, HistoryIcon } from 'lucide-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { getCountryName } from '~/helpers/country'
import { makeShopOwnPath } from '~/helpers/routes'
import { useOptionalSeller } from '~/hooks/data/use-seller'
import { useShop } from '~/hooks/data/use-shop'
import type { ShippingCountryCode } from '~/schemas/country'
import { Tag } from '~/ui'

export const ShopShippingAndReturns = () => {
  const shop = useShop()
  const seller = useOptionalSeller()
  const { t } = useTranslation()

  const labels = useMemo(() => {
    const { dispatchCountry, dispachWithinDays, returnWithinDays } = shop

    let shipping = null
    let returns = null

    if (dispachWithinDays && dispachWithinDays > 1) {
      shipping = t('page.home.ships_from_days', {
        country: dispatchCountry
          ? getCountryName(dispatchCountry as ShippingCountryCode)
          : '',
        days: dispachWithinDays,
      })
    } else if (dispachWithinDays && dispachWithinDays === 1) {
      shipping = t('page.home.ships_from_day', {
        country: dispatchCountry
          ? getCountryName(dispatchCountry as ShippingCountryCode)
          : '',
      })
    }

    if (returnWithinDays) {
      returns = t('page.home.return_accepted', {
        days: returnWithinDays,
      })
    }

    return { shipping, returns }
  }, [shop, t])

  if (!seller) {
    return (
      <>
        {labels.returns && (
          <Tag>
            <Tag.Icon>
              <HistoryIcon />
            </Tag.Icon>
            {labels.returns}
          </Tag>
        )}

        {labels.shipping && (
          <Tag>
            <Tag.Icon>
              <EarthIcon />
            </Tag.Icon>
            {labels.shipping}
          </Tag>
        )}
      </>
    )
  }

  return (
    <>
      {labels.returns && (
        <Tag asChild interactive>
          <Link to={makeShopOwnPath(shop, '/settings/shipping#returns')}>
            <Tag.Icon>
              <HistoryIcon />
            </Tag.Icon>
            {labels.returns}
          </Link>
        </Tag>
      )}

      {labels.shipping && (
        <Tag asChild interactive>
          <Link to={makeShopOwnPath(shop, '/settings/shipping#shipping')}>
            <Tag.Icon>
              <EarthIcon />
            </Tag.Icon>
            {labels.shipping}
          </Link>
        </Tag>
      )}
    </>
  )
}
